module.exports = __webpack_public_path__ + "static/media/workDaySchedulerS.4ce66118.png";